import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/reset.scss'

createApp(App).use(ElementPlus, { locale }).use(store).use(router).mount('#app')
